import { DesignData, MediaImageQrCode, Spread } from 'editor/src/store/design/types';

/** The texts one QR reads through an `element` source, when it is artwork only. */
export function getQrCodeSourceTextUuids(qrCode: MediaImageQrCode | undefined): Set<number> {
  const uuids = new Set<number>();
  // Defensive: a design could carry a malformed/hand-authored qrCode object.
  if (!qrCode?.artworkOnly || !Array.isArray(qrCode.fields)) {
    return uuids;
  }
  qrCode.fields.forEach(({ source }) => {
    if (source?.type === 'element') {
      uuids.add(source.elementId);
    }
  });
  return uuids;
}

/**
 * The texts on `spread` that an artwork-only QR anywhere in the design reads. They hold
 * the QR's data, such as the buyer's URL, so they are not drawn; the Personalize panels
 * still list them for editing.
 */
export function getSpreadQrSourceTextUuids(
  designData: Pick<DesignData, 'spreads'> | undefined,
  spread: Pick<Spread, 'pages'>,
): Set<number> {
  const read = new Set<number>();
  designData?.spreads.forEach((designSpread) =>
    designSpread.pages.forEach((page) =>
      page.groups.media?.forEach((element) => {
        if (element.type === 'image') {
          getQrCodeSourceTextUuids(element.qrCode).forEach((uuid) => read.add(uuid));
        }
      }),
    ),
  );

  const uuids = new Set<number>();
  if (!read.size) {
    return uuids;
  }
  spread.pages.forEach((page) =>
    page.groups.media?.forEach((element) => {
      if (element.type === 'text' && read.has(element.uuid)) {
        uuids.add(element.uuid);
      }
    }),
  );
  return uuids;
}
